import { text } from '#contract'
import type { LocalizedText } from '#contract'
import { useT } from '../../../i18n/index.ts'
import styles from './checkout.module.css'
import { useShop } from './shop-context.ts'

/** "1 item", "3 items". */
export function itemsText(n: number): LocalizedText {
  return n === 1 ? text('shop.item') : text('shop.items', { n })
}

/** Sticky at the bottom while the basket has something: its count, "View basket", the subtotal. */
export function BasketBar() {
  const t = useT()
  const { summary, money, nav } = useShop()
  if (summary.items === 0) return null
  const subtotal = money(summary.subtotalCents)
  return (
    <div class={styles.dock}>
      <button
        type="button"
        class={styles.basketBar}
        aria-label={t(text('shop.basketBar', { items: itemsText(summary.items), money: subtotal }))}
        onClick={() => {
          nav.push({ kind: 'basket' })
        }}
      >
        <span key={summary.items} class={styles.barCount}>
          {summary.items}
        </span>
        <span>{t(text('shop.viewBasket'))}</span>
        <span class={styles.barTotal}>{subtotal}</span>
      </button>
    </div>
  )
}
